<template lang='pug'>
//- Side-Effect-Summary
.custom-scrollbar(:class='$style[`cc-side-effect-summary`]')
  //- div(:class='$style[`cc-side-effect-summary-navbar`]')
  //-   router-link(
  //-     v-if='rwdType !== `desktop`'
  //-     tag='button'
  //-     role='button'
  //-     tabindex='0'
  //-     aria-label='返回'
  //-     :to='`/sideeffect/record`'
  //-     :class='$style[`cc-side-effect-summary-btn`]')
  //-     IconOpenArrow(:size='20' :color='`#262626`')

    //- button(
    //-   tabindex='0' aria-label='瀏覽歷史健檢報告'
    //-   :class='[$style[`cc-side-effect-summary-btn`], $style[showType === `analysis` ? `cc-selected` : ``]]'
    //-   @click='handleClickSwitchNav(`analysis`)') 健檢 / 預測分析

    //- button(
    //-   tabindex='0' aria-label='瀏覽趨勢變化圖'
    //-   :class='[$style[`cc-side-effect-summary-btn`], $style[showType === `charts` ? `cc-selected` : ``]]'
    //-   @click='handleClickSwitchNav(`charts`)') 趨勢變化

  div(:class='$style[`cc-side-effect-summary-wrap`]')
    EffectAnalysis
  //- div(v-if='showType === `analysis`' :class='$style[`cc-side-effect-summary-wrap`]')
  //-   EffectAnalysis
  //- div(v-else-if='showType === `charts`' :class='$style[`cc-side-effect-summary-wrap`]')
  //-   EffectCharts



</template>

<script>
import { mapGetters } from 'vuex';
import EffectCharts from './EffectCharts';
import EffectAnalysis from './EffectAnalysis';
import IconOpenArrow from '../../icon/OpenArrow';


export default {
  components: {
    EffectCharts,
    EffectAnalysis,
    IconOpenArrow,
  },

  data() {
    return {
      showType: 'analysis', // charts
    };
  },

  methods: {
    handleClickSwitchNav(feature) {
      this.showType = feature;
    },
  },

  computed: {
    ...mapGetters({
      // loginDjangoId: 'user/exportUserDjangoId',
      rwdType: 'global/exportRwdType',
    }),
  },
};
</script>

<style module lang='scss'>
  @import '../../../sass/component/page/sideeffect/effectSummary.scss';
</style>
